
import {
	Component,
	EventEmitter,
	inject,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoPulseTourService } from '@go-modules/services/go-pulse-tour/go-pulse-tour.service';
import { ACTIVITY_TASK_INSTRUCTOR_PILLS_TOUR_CONFIG } from '@go-modules/services/go-pulse-tour/constants/activity-task-tour-instructor';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

export interface PillToggleOption {
	value: string;
	label: string;
	class?: string;
}

@Component({
	standalone: true,
	selector: 'pill-toggle',
	templateUrl: './pill-toggle.component.html',
	styleUrls: ['./pill-toggle.component.scss'],
	imports: [TranslateModule]
})
export class PillToggleComponent implements OnInit {
	@Output() public onOptionSelect = new EventEmitter<string>();
	@Input() public options: PillToggleOption[] = [];
	@Input() public selectedOption: string | null = null;
	@Input() public ariaLabel: string = 'pill-toggle_aria-label';
	protected pulseTourService = inject(GoPulseTourService);

	public ngOnInit (): void {
		this.pulseTourService.startTour(ACTIVITY_TASK_INSTRUCTOR_PILLS_TOUR_CONFIG).pipe(
			catchError(() => EMPTY)
		).subscribe();
	}
}
